import cookies from '../constants/cookies';
import Cookies from 'js-cookie';
import events from '../constants/events';

export function handleRedirect() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if(queryString) {

    for (const [key, value] of urlParams) {
      switch (key) {
        case 'redirect':
          Cookies.set(cookies.SELECTED_LOCATION, value, { expires: 1 });
        break;

        case 'sku':
          window.addEventListener(events.PRODUCT_DATA_LOADED, () => {
            const { productData } = window.mosmosh;
            for(const product in productData) {
              if(productData[product].firstSKU === value) {
                // Preserve the hash when redirecting
                const currentHash = window.location.hash;
                const productUrl = productData[product].url;
                const finalUrl = currentHash ? productUrl + currentHash : productUrl;
                window.location.href = finalUrl;
                break;
              }
            }  
          });
        break;
      
        default:
          //nothing
        break;
      }
    }
  }
}